.bookieSelection {
  display: grid;
  grid-template-columns: 60px 0.75fr 1fr 1fr 1fr;
  align-items: center;
  border-bottom: 1px solid var(--ogm-mavericks);
  z-index: var(--cxy-z-index-internal-mid);
  grid-gap: 8px;
  padding: 8px;
}
.bookieSelection .bookieLogo {
  display: block;
  height: 60px;
  width: 60px;
  border-radius: 3px;
  cursor: pointer;
}
.bookieSelection.selected {
  padding: 0;
  grid-template-columns: 50px 0.75fr 1fr 0.75fr 1fr;
  height: 76px;
}
.bookieSelection.selected .bookieLogo {
  height: 50px;
  width: 50px;
}
.bookieSelection .bookieBackground {
  width: 100%;
  height: 76px;
  opacity: 0.15;
  border-radius: 3px;
  position: absolute;
  pointer-events: none;
  z-index: var(--cxy-z-index-internal-base);
}
.bookieSelection .sectionWrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 55px;
}
.bookieSelection .sectionWrapper .title {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 12px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
}
.bookieSelection .sectionWrapper .number,
.bookieSelection .sectionWrapper .odds {
  color: var(--ogm-black);
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 5px 0;
}
.bookieSelection .sectionWrapper .odds {
  color: var(--ogm-bucks);
}
.bookieSelection .button {
  padding: 8px;
  width: auto;
  height: 40px;
  background: var(--ogm-seahawks);
  color: var(--ogm-black);
}
.bookieSelection .button svg {
  margin-right: 4px;
}
.bookieSelection .button:hover {
  opacity: 0.75;
}
.bookieSelection .signUpButton {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  white-space: nowrap;

  height: 100%;
  cursor: pointer;
}
.bookieSelection .signUpButton svg {
  margin-right: 4px;
}
.bookieSelection:not(.selected):hover {
  background-color: var(--ogm-mavericks);
}

@media (max-width: 767px) {
  .bookieSelection {
    margin-left: 0;
  }
}
@media (max-width: 320px) {
  .bookieSelection {
    padding-left: 0;
    width: 100%;
  }
  .bookieSelection .sectionWrapper .title,
  .bookieSelection .sectionWrapper .odds {
    font-family: var(--ogm-font-family-2);
    font-weight: 400;
    font-size: 12px;
    line-height: 1.2em;
    text-transform: none;
  }
  .bookieSelection .sectionWrapper .number,
  .bookieSelection .sectionWrapper .odds {
    font-family: var(--ogm-font-family-2);
    font-weight: 700;
    font-size: 14px;
    line-height: 1.2em;
    text-transform: none;
  }
  .bookieSelection .button {
    font-size: 12px;
    height: 30px;
    margin-right: 12px;
  }
}

[data-fpsm-theme='gazzetta'] {
  .bookieSelection .sectionWrapper .odds {
    color: var(--cxy-color-content-default);
  }
}
